import React from 'react';
import { UnstyledButton } from '@/components/ui/Buttons';
import { TCITooltip } from '@/components/ui/Tooltip';
import Icon from '@/components/ui/Icon';
import { COLORS } from '@/components/ui/ui.constants';
import { useModalManager } from '@/components/common/Modal';
import SyncActivity from '@/components/shared/SyncActivity';
import { IStudent } from '../../types';

interface ViewGradeSyncActivityButtonProps {
  assignmentId: number;
  student: IStudent;
}

// TCI-staff-only shortcut into the grade sync log, scoped to this one student and assignment.
// Only rendered when the real (impersonating) staffer is a Sysadmin — see the `isSysadmin` prop
// on the grades table, which reads `true_staffer`, not the teacher being masqueraded as.
const ViewGradeSyncActivityButton = ({ assignmentId, student }: ViewGradeSyncActivityButtonProps) => {
  const modalManager = useModalManager();
  const label = `View grade sync activity for ${student.first_name} ${student.last_name}`;

  return (
    <>
      <TCITooltip>
        <TCITooltip.Trigger asChild>
          <UnstyledButton
            aria-label={label}
            className="tw-inline-flex tw-items-center tw-justify-center"
            type="button"
            onClick={modalManager.open}
          >
            <Icon fill={COLORS['tci-black']} icon="Info" size={16} />
          </UnstyledButton>
        </TCITooltip.Trigger>
        <TCITooltip.Content>
          {label}
        </TCITooltip.Content>
      </TCITooltip>
      <SyncActivity
        gradeSyncOnly
        linkToDashboard
        assignmentId={assignmentId}
        isOpen={modalManager.isOpen}
        studentId={student.id}
        studentLabel={`${student.first_name} ${student.last_name}`}
        onClose={modalManager.close}
      />
    </>
  );
};

export default ViewGradeSyncActivityButton;
